import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Modal from 'react-modal'
import cn from 'classnames'
import { useLocation } from 'react-router'

import { changePhoneNumber, transfer, setupCall } from 'store/actions/call'
import { CallPageTypes, ContactsPageTypes } from 'common/Enums'
import { ReactComponent as HandSetIcon } from 'assets/svg/shared/handsetcall.svg'
import { ReactComponent as CloseIcon } from 'assets/svg/shared/close.svg'
import { ReactComponent as UserAvatarIcon } from 'assets/svg/recents/user_avatar.svg'
import { modalStyles } from './ModalStylesObj'
import './WebphoneModal.scss'
import { useTranslation } from 'react-i18next'
import { navigateCallPage } from 'hooks'
import { sipNumberFormat } from 'utils/numberUtils'

export const WebphoneModal = ({ isModalVisible, toggleModal, modalData, slug, backHandler }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const location = useLocation()

    // Store data
    const { calls } = useSelector((state) => state.call)
    // Computed
    const currentCall = calls.find((item) => item.isActive)
    const isTransferCall = slug === ContactsPageTypes.TransferCall

    // Actions
    function doAfterAction() {
        toggleModal && toggleModal()
        backHandler && backHandler()
    }
    function transferCallHandler() {
        dispatch(
            transfer({
                transferingNumber: currentCall.number,
                transferToNumber: modalData.phoneNumber
            })
        )
        doAfterAction()
    }

    function addNewCallHandler() {
        dispatch(
            changePhoneNumber({
                activeNumber: currentCall?.number,
                number: modalData.phoneNumber
            })
        )
        dispatch(setupCall({ number: sipNumberFormat(modalData.phoneNumber) }))
        if (
            location.pathname.indexOf('contacts') > -1 ||
            location.pathname.indexOf('recents') > -1 ||
            location.pathname.indexOf('dialpad') > -1
        ) {
            // useCallPage({ callPageType: CallPageTypes.Single })
            navigateCallPage({ callPageType: CallPageTypes.Single })
        }
        doAfterAction()
    }

    // Renders
    function renderFooter() {
        switch (slug) {
            case ContactsPageTypes.AddContact:
                return (
                    <div className="webphone-modal__footer d-flex justify-content-center align-items-center">
                        <button type="button" className="webphone-modal__action-btn d-flex" onClick={addNewCallHandler}>
                            <HandSetIcon />
                            {t('call_now')}
                        </button>
                    </div>
                )
            case ContactsPageTypes.TransferCall:
                return (
                    <button type="button" className="webphone-modal__action-btn d-flex" onClick={transferCallHandler}>
                        <HandSetIcon />
                        {t('transfer_now')}
                    </button>
                )
            default:
                return (
                    <button type="button" className="webphone-modal__action-btn d-flex" onClick={addNewCallHandler}>
                        <HandSetIcon />
                        {t('call_now')}
                    </button>
                )
        }
    }

    return (
        <Modal isOpen={isModalVisible} onRequestClose={toggleModal} style={modalStyles} ariaHideApp={false}>
            <div className="webphone-modal d-flex flex-column align-items-center">
                <button type="button" className="webphone-modal__close" onClick={toggleModal}>
                    <CloseIcon />
                </button>

                {(modalData.imgSrc && (
                    <img src={modalData.imgSrc} alt="avatar" className="webphone-modal__avatar" />
                )) || <UserAvatarIcon />}
                {modalData.customContent && (
                    <div className="d-flex justify-content-center mb-2">{modalData.customContent()}</div>
                )}
                <div className="webphone-modal__text-wrapper">
                    {isTransferCall && <span className="webphone-modal__text">{t('confirm_transfer')}</span>}
                    <span className={cn('webphone-modal__text', isTransferCall && 'webphone-modal__text--bold')}>
                        {modalData.text}
                    </span>
                    {isTransferCall && <span className="webphone-modal__text">?</span>}
                </div>

                {modalData.duration && <span className="webphone-modal__text--light">{modalData.duration}</span>}

                {renderFooter()}
            </div>
        </Modal>
    )
}
